import React from 'react';
import {Link} from 'react-router-dom';
import {default as Carousel} from './Carousel';

var MainContent = props => {
  return (
    <div className="main">
      <div className="row top-section">
      <div className="logo-row">
          <img className="logo-pic" src={"img/new-logo.png"}></img>
          <div className="titles">
            <h1 className="title">Walter M. Cunningham Education Foundation</h1>
            <p className="subtitle">A Sister Organization of the <a href="http://ucls.org">Utah Council of Land Surveyors</a></p>
          </div>
      </div>
        <div className="container title-section">
          <div className="row">
            <div className="col-md-6 col-sm-12 title-text">
              <img className="cunningham-pic" src={"img/walt.jpg"}></img>
              <p className="title-text waltTitle">Walter M. Cunningham, PLS, BS, Associate Professor</p>
            </div>
            <div className="col-md-6 col-sm-12">
              <p>
              The Walter M. Cunningham Education Foundation is organized as a nonprofit corporation to provide
              funding and grants to low-income students and to provide academic opportunities and educational experiences
              to Surveying, Mapping, and Geomatics students.
              </p>
              <h3 className="title-text-right">Purpose of the Foundation</h3>
              <ul className="foundation-list">
                <li>to act and operate exclusively for charitable and educational purposes</li>
                <li>to cultivate partnerships with public and private organizations committed to ensuring access to applicable learning opportunities</li>
                <li>to fund educational experiences that focus on creativity, commitment to others, and that cultivate social responsibility</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row bio-section">
        <div className="container">
          <div className="row">
          <div className="col-md-12">
            {
              //<img className="cunningham-pic" src={"img/cunnningham-portrait.jpg"}></img>
            }
            <div className="bio-right">
              {
                //<h2 className="bio-title">Bio of Walter Cunningham</h2>
              }
              <p className="bio">
              Walt Cunningham’s surveying career started in 1966 while helping a local land surveyor find property-corner monuments for a
              construction project on Alaska’s Kenai Peninsula. He has since performed private and public-sector work on a wide variety of construction,
              boundary, public-lands, mapping, and oil-field projects in Alaska, Utah, Wyoming, and Nevada, including the Trans-Alaska Oil Pipeline.
              A passionate believer in combining real-world work experience with formal education, Walt earned a BS degree in Mapping from Brigham Young
              University in 1988, followed by a Utah Professional Land Surveyor’s (PLS) license in 1991. While operating his full-time surveying business,
              he was hired by Salt Lake Community College (SLCC) in 1994 as an Adjunct surveying faculty member. In 2004 he accepted a full-time position at SLCC,
              where he coordinated the Surveying & Geomatics Program and taught in it as an Associate Professor. He was a member of the Advisory Board for Utah
              Valley University’s (UVU) four-year Geomatics degree program, and served two years on the National Society of Professional Surveyors’ (NSPS) Certified
              Surveying Technician (CST) Board, representing Utah among other western states. He similarly served for three years on the SLCC Faculty Senate. He became
              acquainted with the Utah Council of Land Surveyors (UCLS) while at BYU, and has since been an avid supporter of the UCLS by serving at the Chapter and State
              levels in various positions and assignments, including Chair of the Education Committee. Walt was honored by the UCLS as the 2006 Utah Surveyor of the Year, and
              by the Utah Engineers Council as a 2013 Engineering Educator of the Year.  Thanks to the overwhelming support of his many students and SLCC faculty members, he
              became a recipient of the 2015 SLCC Foundation’s Teaching Excellence Award. He retired from SLCC in 2017.
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row col-section">
          <div className="col-md-6 col-sm-12 left-col">
            <Carousel />
          </div>
            <div className="col-md-6 col-sm-12 right-col">
            <div className="donate-section">
              <h2 className="donate-title">Donate</h2>
              <p className="donate-text">Your donation will help a student pay for a computer, school supplies, or even a meal.  Give back to your profession by supporting the next generation.</p>
              <Link to="/donate" id="donate-button" className="button">Donate</Link>
            </div>
            <div className="scholarship-section">
              <h2 className="scholarship-title">Scholarship</h2>
              <p className="scholarship-text">Apply Now for next year’s scholarship.</p>
              <Link to="/scholarship" id="scholarship-button" className="button">Scholarship</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/MainContent.js